import { render } from "./PoliciesSupport.vue?vue&type=template&id=c1fb71ae"
import script from "./PoliciesSupport.vue?vue&type=script&lang=js"
export * from "./PoliciesSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__